/**
 * The user session expected event types.
 * @type {Object<String>}
 */
export const EVENT_TYPES = {
    SIGN_IN: 'sign_in',
    SIGN_UP: 'sign_up'
};

/**
 * The event types to platform mapping to report.
 * @type {Object<String>}
 */
export const EVENTS = {
    [EVENT_TYPES.SIGN_IN]: {
        mixpanel: 'Clicked login',
        bigQuery: 'login_click'
    },
    [EVENT_TYPES.SIGN_UP]: {
        mixpanel: 'Clicked join',
        bigQuery: 'signup_click'
    }
};
